module.exports = __webpack_public_path__ + "static/7cac0e3e-5645-41a2-8fd3-70bf7cf01c42-500.4720a1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-pirans-chapel-trevethy-tintagel/7cac0e3e-5645-41a2-8fd3-70bf7cf01c42-500.jpg
// module id = 1216
// module chunks = 168707334958949